module.exports = __webpack_public_path__ + "img/tuto_mobile_way_01_07.42a1f4f9.png";